import { API_BASE_URL } from "../../../configurations/configurations";
import { mainApiSlice } from "../api/mainApiSlice";

export const usersManagementAPi = mainApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // get a single user
    getUserByUserId: builder.query({
      query: (userId) => ({
        url: `${API_BASE_URL}/users/user/${userId}`,
        method: "GET",
      }),
      providesTags: (result, error, userId) => [{ type: "User", id: userId }],
    }),
    // get users associated to the admin
    getUsersByAdminId: builder.query({
      query: ({ admin_id, page, search, statusFilter }) => {
        let params = new URLSearchParams();
        params.append("page", page);
        if (search) {
          params.append("search", search);
        }
        if (statusFilter) {
          params.append("status_filter", statusFilter);
        }
        return {
          url: `${API_BASE_URL}/users/${admin_id}?${params.toString()}`,
          method: "GET",
        };
      },
      provideTags: (result) =>
        result
          ? [
              ...result.paginated_results.map(({ id }) => ({
                type: "User",
                id,
              })),
              { type: "UserList", id: "LIST" },
            ]
          : [{ type: "UserList", id: "LIST" }],
    }),
    // aggiorno un singolo user
    updateSingleUser: builder.mutation({
      query: ({ userId, ...details }) => ({
        url: `${API_BASE_URL}/users/user/${userId}`,
        method: "PUT",
        body: details,
      }),
      invalidatesTags: (result, error, { userId }) => [
        { type: "User", id: userId },
        { type: "UserList", id: "LIST" },
      ],
    }),
  }),
});

export const {
  useGetUsersByAdminIdQuery,
  useGetUserByUserIdQuery,
  useUpdateSingleUserMutation,
} = usersManagementAPi;
